/* eslint-disable global-require */
module.exports = {
  CITIES: require('./cities'),
  COMPANY: require('./company'),
  CONSTANTS: require('./constants'),
  CONTRACTS: require('./contracts'),
  DOCGROUPS: require('./docgroups'),
  DOCS: require('./docs'),
  LIBRARY: require('./library'),
  NOTIFICATIONS: require('./notifications'),
  PROFESSIONS: require('./professions'),
  PUSH: require('./push'),
  SERVICES: require('./services'),
  SPECS: require('./specs'),
  STATUSES: require('./statuses'),
  COUNTERS: require('./counters'),
  DOCS_ADDITIONAL_TEXTS: require('./docsAdditionalTexts'),
  EXTERNAL_APPLICANT: require('./externalApplicant'),
  DATE_OF_PAYMENT: require('./dateOfPayment'),
  FULL_TIME: require('./fullTime'),
  WHATS_APP_TEMPLATES: require('./whatsAppTemplates'),
  TYPES_ORDERS: require('./typesOrders'),
  INTERVIEW: require('./interview'),
  ACTIONS_IDS: require('./actionsIds'),
  USER_ROLES: require('./roles').USER_ROLES,
  OPERATOR_ROLES: require('./roles').OPERATOR_ROLES,
  NATIONAL_ACCESSIBILITY: require('./nationalAccessibility'),
  CITIZENSHIP: require('./citizenship').CITIZENSHIP,
  CITIZENSHIP_CATEGORY: require('./citizenship').CITIZENSHIP_CATEGORY,
};
